import { browser } from '$app/environment';
import { writable } from 'svelte/store';

const smSize = 640;
const mdSize = 768;
const lgSize = 1024;
const xlSize = 1280;
const xxlSize = 1536;

export interface ResponsiveSizeInfo {
  height: number;
  width: number;

  sm: boolean;
  md: boolean;
  lg: boolean;
  xl: boolean;
  xxl: boolean;
}

export const size = writable<ResponsiveSizeInfo>({
  height: 0,
  width: 0,

  sm: true,
  md: true,
  lg: true,
  xl: true,
  xxl: true,
});

function updateSizing() {
  const height = window.innerHeight;
  const width = window.innerWidth;

  size.update(() => ({
    height,
    width,

    sm: width >= smSize,
    md: width >= mdSize,
    lg: width >= lgSize,
    xl: width >= xlSize,
    xxl: width >= xxlSize,
  }));
}

if (browser) {
  updateSizing();
  window.addEventListener('resize', updateSizing);
}
